import config from '@/config.js'
import type { Space } from '@/types'
import { removeS3InformationFromURL } from '../specifics'

export const getAssetFilename = (filename: string, space: Space): string => {
  const url = removeS3InformationFromURL(filename)

  if (space.asset_cdn) {
    return url.replace(`//${config.get('bucket')}/`, `//${space.asset_cdn}/`)
  }

  return url
}

/**
 * @function getParsedFilenameFromURL Function to extract fileName and format from a url
 * @param  {string} path File url
 * @return {Object} Object containing format and name
 *
 * @example
 * getParsedFilenameFromURL('https://a.storyblok.com/f/93669/x/6e2d83aa2e/story-image.jpeg')
 * // returns { name: 'story-image', format: 'jpeg' }
 */

type ParsedFilename = {
  name: string
  format: string
}

export const getParsedFilenameFromURL = (path: string): ParsedFilename => {
  const url = path.split('?')[0].split('/')
  const filename = url[url.length - 1]
  const data = filename.split('.')
  const name = data.slice(0, data.length - 1).join('.')
  const format = `${data[data.length - 1]}`

  return { name, format }
}
